import React from "react";
import "../../styles/FunPage.scss";
import Explore from "./Explore";
import Visit from "./Visit";
import Feast from "./Feast";
import Video from "./Video";


export default function FunPage() {
  return (
    <div className="fun-wrapper">

      <section className="fun-top-section">
        <div className="fun-top-inner">
          <h3 className="fun-cutout fun-top-small">What's Fun?</h3>
          <h1 className="fun-cutout fun-top-main">Experience</h1>
          <h2 className="fun-cutout fun-top-sub">The Philippines</h2>
        </div>
      </section>

      <section className="fun-image-section">
        <div className="fun-image-overlay">
          <h2>Historic Town of Vigan</h2>
          <p>Vigan City, Ilocos Sur</p>
        </div>
        <div className="fun-vigan-caption">
          <span>© UNESCO</span>
        </div>
      </section>

      <section className="fun-rice-section">
        <div className="fun-rice-overlay"></div>
        <div className="fun-rice-text">
          <h1 className="fun-rice-left">It’s more than a congress —</h1>
          <h1 className="fun-rice-right">It’s an adventure.</h1>
        </div>

        <div className="fun-rice-paragraph">
          <p>
            When you come to the Philippines for APLIC 2027, you’re not just attending a world class 
            conference — you’re stepping into a nation bursting with energy, color, and heart. Known for its 
            warm hospitality and boundless charm, the Philippines offers a perfect blend of business and 
            leisure, culture and creativity, island life and urban pulse.
          </p>
        </div>

        <div className="fun-rice-caption">
          Rice Terraces of the Philippine Cordilleras  
          <span>© UNESCO</span>
        </div>
      </section>
      <Explore />
      <Visit />
      <Feast/>
      <Video/>

       <section className="fun-final-section">
        <button className="fun-register-btn" onClick={() => window.open("https://aplic2027.gottit.io/", "_blank")}><span className="fun-register-btn-text">Register</span></button>

        <p className="fun-final-text">
          So pack your bags, bring your sense of wonder, and get ready to
          experience the perfect balance of business and pleasure.
        </p>

        <p className="fun-final-text">
          At APLIC 2027, Success in Motion continues — even after the sessions end.
        </p>
      </section>

    </div>
  );
}
